
<val-boite-dialogue-generique #boiteDialogue
                              class="val-boite-dialogue-messages"
                              [ngClass]="ClassesType"
                              [titre]="titre"
                              [validerVisible]="false"
                              [annulerVisible]="false">
  <div contenu
       class="val-boite-dialogue-messages-contenu val-flex-conteneur">
    <div class="val-boite-dialogue-messages-icone"
         [ngClass]="{'val-invisible': icone === '' && IconeFonteAffichee === ''}">
      @if (IconeFonteAffichee) {
        <val-fonte-icone [iconeCss]="IconeFonteAffichee" [couleurIcone]="iconeCouleur"></val-fonte-icone>
      } @else {
        <val-simple-image [src]="'assets/' + icone"></val-simple-image>
      }
    </div>
    <div class="val-flex-conteneur val-flex-colonne">
      @for (message of messages; track $index)
      {
        <val-simple-libelle [libelle]="message"></val-simple-libelle>
      }
    </div>
  </div>
  <div commandes
       class="val-boite-dialogue-messages-commandes val-flex-conteneur">
    <div class="val-flex-1"></div>
    <val-simple-bouton [libelle]="TexteOk"
                       (boutonClick)="Fermer()">
    </val-simple-bouton>
  </div>
</val-boite-dialogue-generique>
